/* --- RESET PASSWORD MODULE --- */
export const SEND_RECOVERY_MAIL = "SEND_RECOVERY_MAIL";

/* --- COMMUNICATIONS MODULE --- */
export const LOAD_COMMUNICATIONS = "LOAD_COMMUNICATIONS";
